import { Button } from "./ui/button";

export default function AdmissionStatus({ queue, onCancel }) {
  if (!queue) return null;
  return <div role="status" aria-live="polite" data-testid="admission-queue" className="border border-primary bg-primary/5 p-5 space-y-3 text-sm">
    <div className="label-eyebrow text-primary">fila de entrada</div>
    <h3 className="font-display text-2xl font-black">{queue.position > 0 ? `Sua posição: ${queue.position}` : "É a sua vez"}</h3>
    <p>{queue.message}</p>
    <p className="text-muted-foreground">Mantenha esta tela aberta. A entrada será automática; não precisa clicar novamente. O tempo da prova ainda não começou.</p>
    <Button variant="outline" type="button" onClick={onCancel} className="rounded-none">Sair da fila</Button>
  </div>;
}
